var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.9346 0 0 4.9346 0 11V15.5573C0 16.6837 0.9867 17.6 2.2 17.6H3.3C3.59174 17.6 3.87153 17.4841 4.07782 17.2778C4.28411 17.0715 4.4 16.7917 4.4 16.5V10.8427C4.4 10.551 4.28411 10.2712 4.07782 10.0649C3.87153 9.85859 3.59174 9.7427 3.3 9.7427H2.3012C2.9128 5.4857 6.5758 2.2 11 2.2C15.4242 2.2 19.0872 5.4857 19.6988 9.7427H18.7C18.4083 9.7427 18.1285 9.85859 17.9222 10.0649C17.7159 10.2712 17.6 10.551 17.6 10.8427V17.6C17.6 18.8133 16.6133 19.8 15.4 19.8H13.2V18.7H8.8V22H15.4C17.8266 22 19.8 20.0266 19.8 17.6C21.0133 17.6 22 16.6837 22 15.5573V11C22 4.9346 17.0654 0 11 0Z",
    fill: "#5282F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.81632e58fa5042604f8c60495ff03fbe.svg";
export { ForwardRef as ReactComponent };